import { render, staticRenderFns } from "./SessionExpiredDialog.vue?vue&type=template&id=1197cb8c&scoped=true"
import script from "./SessionExpiredDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SessionExpiredDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1197cb8c",
  null
  
)

export default component.exports